import './HistogramSelectionAreaTooltip.css';
export var disabledActions = '_vbjom50-2-0-1';